export const PageHeader = ({ title, description, actions }) => {
  return (
    <div className="page-header">
      <div className="max-w-7xl mx-auto px-6 py-6 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 className="font-secondary font-bold text-2xl md:text-3xl text-slate-900 tracking-tight">
              {title}
            </h1>
            {description && (
              <p className="text-slate-500 mt-1 text-sm md:text-base">{description}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-3">
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
